import { render, staticRenderFns } from "./Rests.vue?vue&type=template&id=489e4153"
import script from "./Rests.vue?vue&type=script&lang=js"
export * from "./Rests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports